export const createArrayWithValues = (ln, startingFrom = 0) =>
  Array.from({ length: ln }, (_, index) => startingFrom + index + 1);
